var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveBidNameBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 899,
    height: 343,
    viewBox: "0 0 899 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H899L806.5 286L91 285L1 16Z",
    fill: "url(#paint0_radial_16501_148)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.782 264.254L222.199 271.2C209.859 251.246 202.608 234.636 199.274 220.599C199.274 220.599 197.493 212.401 186.157 211.013C174.821 209.626 199.573 221.823 156.105 217.155C141.107 215.546 115.149 198.037 103.532 185.647C117.79 184.08 143.48 188.886 161.171 185.27C169.891 180.946 167.112 170.995 165.827 167.207C164.54 163.42 161.843 157.931 159.127 155.007C147.355 142.333 133.897 133.62 119.219 124.514C124.779 134.901 127.41 142.911 132.97 153.297C133.895 155.024 137.768 159.456 136.952 161.238C135.969 163.383 129.609 165.911 127.261 165.891C98.8847 165.644 74.304 151.419 54.4893 130.991C51.0548 127.45 47.7868 123.544 46.2187 118.856C44.6518 114.167 44.9679 96.6889 49.6686 98.1458C75.5824 106.183 120.937 103.094 106.652 96.7451C98.8787 93.29 76.6609 90.7819 55.1585 82.3638C37.1485 75.3128 20.0668 63.2756 8.31372 51.1702C32.2251 68.7279 63.5993 91.1249 113.478 85.5918C129.963 89.6327 108.078 105.106 99.6806 107.436C83.687 111.872 66.322 115.371 50.3363 110.897C62.8301 127.829 83.2463 146.136 101.217 157C106.106 159.954 115.452 161.042 119.878 157.425C124.926 153.299 114.73 125.232 110.715 114.068C122.494 116.694 156.455 150.62 169.766 158.909C174.88 162.095 181.455 167.969 180.019 169.939C179.032 174.794 172.842 179.942 168.549 182.378C154.321 190.451 137.717 193.927 121.598 191.232C148.728 214.94 173.815 218.987 175.697 208.529C176.676 203.097 192.767 206.964 201.086 213.153C205.862 234.232 216.742 247.272 226.496 263.636C230.48 266.171 242.336 258.788 247.279 259.284C262.107 260.773 276.618 278.633 281.211 286.698C271.344 280.194 248.828 263.709 246.782 264.254Z",
    fill: "url(#paint1_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.913 261.192C249.562 260.015 233.105 264.497 225.946 265.745C218.995 266.974 199.868 214.373 198.351 213.452C192.617 209.975 184.635 207.037 179.614 207.748C179.628 207.794 177.581 207.454 176.56 212.411C175.365 218.14 160.705 216.909 146.119 210.322C135.344 205.451 115.175 192.006 115.559 190.742C115.945 189.477 132.607 190.365 135.105 190.36C148.175 190.336 153.706 187.548 156.192 187.635C140.703 188.275 124.403 187.891 107.418 186.643L106.67 186.601L117.932 196.058L118.565 196.59C127.161 203.887 140.323 212.953 157.804 216.196C164.698 217.474 179.158 217.846 180.947 215.31C181.697 214.256 178.566 210.758 179.846 210.142C180.888 209.659 182.076 209.331 183.419 209.3C188.47 209.167 197.34 213.691 199.148 217.483C201.551 222.541 201.487 226.055 205.851 235.675C212.048 249.339 222.615 269.047 222.615 269.047C222.615 269.047 246.041 262.525 249.088 263.839C251.971 265.103 272.962 276.876 275.003 278.018C272.919 276.684 250.254 262.303 249.913 261.192Z",
    fill: "url(#paint2_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.832 178.15C165.222 184.155 178.022 172.781 177.517 170.064C177.012 167.346 160.269 153.956 160.269 153.956C160.269 153.956 172.442 172.144 168.832 178.15Z",
    fill: "url(#paint3_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 131.273C134 131.273 119.688 119.466 118.632 122.329C117.575 125.193 135.007 158.71 133.008 162.028C131.008 165.347 108.813 165.629 90.2135 155.847C71.6142 146.066 37.8627 121.917 48.3334 100.722C68.608 111.36 109.139 101.164 109.139 101.164C109.139 101.164 95.7409 109.533 71.695 110.817C60.2868 111.425 48.1119 107.45 48.085 108.949C48.0158 112.785 56.047 125.461 71.069 138.959C83.8672 150.461 114.811 170.268 123.677 157.319C126.788 152.775 122.127 140.552 119.538 132.967C116.513 124.105 113.819 117.475 113.819 117.475C117.866 115.538 134 131.273 134 131.273Z",
    fill: "url(#paint4_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.36 187.99C109.36 187.99 136.956 190.337 136.127 189.163C137.035 189.783 114.712 188.806 114.853 190.3C109.742 188.479 149.795 215.897 157.812 216.196C142.154 208.368 126.473 202.369 109.36 187.99Z",
    fill: "url(#paint5_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.44 101.874C48.44 101.874 58.3383 106.571 70.891 107.005C85.7144 107.518 103.541 103.738 103.093 103.103C103.606 103.453 75.3596 111.11 56.5382 107.888C51.9872 107.109 48.8458 105.364 48.8736 105.659C41.6511 113.412 71.3656 142.989 79.6986 148.189C66.551 141.23 41.031 121.904 48.44 101.874Z",
    fill: "url(#paint6_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.345 262.553L223.127 267.761L220.007 261.752C220.007 261.752 224.368 266.886 225.156 266.314C225.942 265.745 245.345 262.553 245.345 262.553Z",
    fill: "url(#paint7_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.545 99.8083C110.725 99.5614 120.055 91.5781 115.201 88.5545C112.938 87.1452 97.6145 89.6274 85.039 87.2745C70.6405 84.5801 49.0033 77.6359 38.0512 73.3707C50.5016 81.4668 89.9023 90.4623 94.7297 90.9017C114.16 92.6711 110.545 99.8083 110.545 99.8083Z",
    fill: "url(#paint8_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.055 177.93C170.407 177.679 176.803 172.23 175.387 170.223C173.97 168.214 164.674 159.041 164.674 159.041C164.674 159.041 174.339 169.193 172.813 172.058C171.286 174.921 170.055 177.93 170.055 177.93Z",
    fill: "url(#paint9_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.656 97.7113C111.779 97.3863 117.775 90.2023 113.804 89.5766C109.832 88.9519 95.4105 89.5284 95.4105 89.5284C95.4105 89.5284 109.686 89.4105 110.894 92.4563C112.099 95.5025 111.656 97.7113 111.656 97.7113Z",
    fill: "url(#paint10_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.134 142.029C124.134 142.029 131.724 158.511 129.826 160.695C126.997 163.951 119.335 161.666 119.335 161.666C119.335 161.666 126.701 161.686 126.993 156.679L124.134 142.029Z",
    fill: "url(#paint11_linear_16501_148)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.43
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.601 264.246L672.183 271.192C684.524 251.238 691.774 234.629 695.109 220.591C695.109 220.591 696.89 212.393 708.226 211.005C719.561 209.619 694.809 221.815 738.278 217.148C753.275 215.539 779.234 198.029 790.851 185.639C776.593 184.073 750.903 188.878 733.212 185.262C724.492 180.939 727.271 170.987 728.556 167.199C729.843 163.412 732.54 157.923 735.256 154.999C747.028 142.325 760.485 133.612 775.164 124.506C769.603 134.893 766.973 142.903 761.413 153.29C760.488 155.017 756.615 159.448 757.431 161.23C758.414 163.375 764.774 165.903 767.122 165.883C795.498 165.636 820.079 151.411 839.894 130.983C843.328 127.442 846.596 123.536 848.164 118.848C849.731 114.159 849.415 96.6811 844.714 98.1379C818.8 106.176 773.446 103.086 787.731 96.7373C795.504 93.2822 817.722 90.774 839.224 82.356C857.234 75.305 874.316 63.2678 886.069 51.1624C862.158 68.7201 830.784 91.1171 780.904 85.584C764.42 89.6249 786.304 105.098 794.702 107.428C810.696 111.865 828.061 115.363 844.047 110.889C831.553 127.822 811.136 146.128 793.166 156.992C788.277 159.946 778.93 161.034 774.505 157.417C769.457 153.291 779.653 125.224 783.668 114.061C771.889 116.686 737.928 150.612 724.617 158.902C719.503 162.087 712.928 167.962 714.364 169.931C715.351 174.787 721.54 179.934 725.833 182.37C740.062 190.443 756.666 193.92 772.785 191.225C745.655 214.932 720.568 218.979 718.685 208.521C717.706 203.089 701.616 206.956 693.297 213.145C688.521 234.224 677.641 247.264 667.887 263.628C663.902 266.163 652.047 258.78 647.104 259.276C632.276 260.765 617.765 278.626 613.172 286.69C623.038 280.186 645.555 263.702 647.601 264.246Z",
    fill: "url(#paint12_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.469 261.184C644.821 260.007 661.277 264.49 668.437 265.737C675.388 266.966 694.515 214.365 696.031 213.444C701.766 209.967 709.748 207.029 714.769 207.74C714.755 207.786 716.802 207.447 717.823 212.403C719.018 218.132 733.678 216.902 748.263 210.315C759.038 205.443 779.208 191.998 778.823 190.734C778.438 189.469 761.776 190.357 759.278 190.353C746.208 190.328 740.677 187.54 738.191 187.627C753.68 188.267 769.979 187.883 786.965 186.635L787.713 186.593L776.451 196.05L775.818 196.582C767.222 203.879 754.06 212.945 736.579 216.188C729.684 217.466 715.225 217.838 713.436 215.302C712.686 214.248 715.817 210.75 714.537 210.134C713.495 209.651 712.307 209.323 710.964 209.292C705.913 209.159 697.043 213.683 695.235 217.475C692.832 222.533 692.896 226.047 688.532 235.668C682.335 249.331 671.768 269.039 671.768 269.039C671.768 269.039 648.342 262.517 645.295 263.831C642.412 265.095 621.421 276.868 619.38 278.01C621.464 276.677 644.129 262.295 644.469 261.184Z",
    fill: "url(#paint13_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.551 178.142C729.161 184.147 716.361 172.773 716.865 170.056C717.37 167.338 734.114 153.948 734.114 153.948C734.114 153.948 721.941 172.136 725.551 178.142Z",
    fill: "url(#paint14_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.383 131.265C760.383 131.265 774.695 119.458 775.751 122.321C776.808 125.185 759.376 158.702 761.375 162.021C763.375 165.339 785.57 165.621 804.169 155.839C822.769 146.058 856.52 121.909 846.049 100.714C825.775 111.352 785.244 101.156 785.244 101.156C785.244 101.156 798.642 109.525 822.688 110.809C834.096 111.418 846.271 107.442 846.298 108.941C846.367 112.777 838.336 125.453 823.314 138.952C810.516 150.453 779.572 170.26 770.706 157.312C767.594 152.768 772.256 140.544 774.845 132.959C777.869 124.097 780.564 117.467 780.564 117.467C776.517 115.53 760.383 131.265 760.383 131.265Z",
    fill: "url(#paint15_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M785.023 187.982C785.023 187.982 757.427 190.329 758.256 189.155C757.348 189.776 779.671 188.799 779.53 190.293C784.64 188.472 744.588 215.889 736.571 216.189C752.229 208.36 767.91 202.361 785.023 187.982Z",
    fill: "url(#paint16_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.943 101.866C845.943 101.866 836.045 106.564 823.492 106.997C808.668 107.51 790.842 103.73 791.29 103.095C790.777 103.445 819.023 111.102 837.845 107.88C842.396 107.101 845.537 105.356 845.509 105.651C852.732 113.404 823.017 142.981 814.684 148.181C827.832 141.222 853.352 121.896 845.943 101.866Z",
    fill: "url(#paint17_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.038 262.545L671.256 267.753L674.376 261.744C674.376 261.744 670.015 266.878 669.227 266.307C668.441 265.737 649.038 262.545 649.038 262.545Z",
    fill: "url(#paint18_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.837 99.8005C783.658 99.5536 774.328 91.5703 779.182 88.5467C781.445 87.1373 796.768 89.6196 809.344 87.2666C823.742 84.5723 845.38 77.6281 856.332 73.3629C843.881 81.459 804.481 90.4545 799.653 90.8938C780.222 92.6633 783.837 99.8005 783.837 99.8005Z",
    fill: "url(#paint19_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.328 177.922C723.976 177.671 717.58 172.223 718.996 170.215C720.413 168.206 729.709 159.033 729.709 159.033C729.709 159.033 720.044 169.185 721.57 172.05C723.097 174.913 724.328 177.922 724.328 177.922Z",
    fill: "url(#paint20_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.727 97.7035C782.604 97.3785 776.608 90.1945 780.579 89.5688C784.551 88.944 798.972 89.5206 798.972 89.5206C798.972 89.5206 784.697 89.4027 783.489 92.4485C782.284 95.4947 782.727 97.7035 782.727 97.7035Z",
    fill: "url(#paint21_linear_16501_148)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.249 142.021C770.249 142.021 762.659 158.503 764.557 160.687C767.386 163.943 775.048 161.658 775.048 161.658C775.048 161.658 767.682 161.678 767.39 156.671L770.249 142.021Z",
    fill: "url(#paint22_linear_16501_148)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M701.003 77.1309C703.007 75.2471 734.484 52.7043 734.484 52.7043L724.748 55.9328L747.312 25.2266L701.003 77.1309Z",
    fill: "#F58220"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.387 79.1387C195.384 77.2549 163.907 54.7121 163.907 54.7121L173.643 57.9406L151.078 27.2344L197.387 79.1387Z",
    fill: "#F58220"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M757.827 122.194L762.643 99.0009L763.899 111.254L785.562 91.8906L757.827 122.194Z",
    fill: "#F58220"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.563 124.202L135.748 101.009L134.491 113.262L112.828 93.8984L140.563 124.202Z",
    fill: "#F58220"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M652.79 175.893L675.805 148.188L665.069 165.676L671.675 163.491L652.79 175.893Z",
    fill: "#F58220"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.593 177.901L222.578 150.195L233.313 167.684L226.708 165.499L245.593 177.901Z",
    fill: "#F58220"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M669 267.221L694.854 229.055L693.222 237.729L711.489 224.881L669 267.221Z",
    fill: "#F58220"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.383 267.221L193.529 229.055L195.161 237.729L176.894 224.881L219.383 267.221Z",
    fill: "#F58220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16501_148",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(449.995 151) scale(388.836 165.344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#004282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#04397B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#112369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020F50"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16501_148",
    x1: 157.711,
    y1: 174.631,
    x2: 72.6622,
    y2: 283.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16501_148",
    x1: 202.651,
    y1: 231.225,
    x2: 152.918,
    y2: 331.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16501_148",
    x1: 168.225,
    y1: 165.406,
    x2: 160.721,
    y2: 181.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16501_148",
    x1: 102.051,
    y1: 127.568,
    x2: 75.7111,
    y2: 200.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_16501_148",
    x1: 136.91,
    y1: 201.901,
    x2: 122.143,
    y2: 229.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_16501_148",
    x1: 84.8119,
    y1: 112.624,
    x2: 76.98,
    y2: 167.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_16501_148",
    x1: 234.698,
    y1: 261.366,
    x2: 235.251,
    y2: 278.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_16501_148",
    x1: 85.2524,
    y1: 81.4913,
    x2: 73.3648,
    y2: 139.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_16501_148",
    x1: 169.542,
    y1: 167.721,
    x2: 164.19,
    y2: 178.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_16501_148",
    x1: 108.245,
    y1: 90.9463,
    x2: 106.004,
    y2: 106.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_16501_148",
    x1: 125.169,
    y1: 153.513,
    x2: 121.391,
    y2: 170.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_16501_148",
    x1: 736.672,
    y1: 174.623,
    x2: 821.721,
    y2: 283.385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_16501_148",
    x1: 691.732,
    y1: 231.217,
    x2: 741.465,
    y2: 331.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_16501_148",
    x1: 726.158,
    y1: 165.398,
    x2: 733.662,
    y2: 181.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_16501_148",
    x1: 792.332,
    y1: 127.56,
    x2: 818.672,
    y2: 200.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_16501_148",
    x1: 757.473,
    y1: 201.894,
    x2: 772.24,
    y2: 229.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_16501_148",
    x1: 809.571,
    y1: 112.616,
    x2: 817.403,
    y2: 167.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_16501_148",
    x1: 659.685,
    y1: 261.358,
    x2: 659.132,
    y2: 278.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_16501_148",
    x1: 809.13,
    y1: 81.4835,
    x2: 821.018,
    y2: 139.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_16501_148",
    x1: 724.841,
    y1: 167.714,
    x2: 730.193,
    y2: 178.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_16501_148",
    x1: 786.137,
    y1: 90.9385,
    x2: 788.379,
    y2: 106.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_16501_148",
    x1: 769.214,
    y1: 153.506,
    x2: 772.991,
    y2: 170.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1083,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2321,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3635,
    stopColor: "#FFF200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5004,
    stopColor: "#FBB040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6414,
    stopColor: "#ECD815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786,
    stopColor: "#F58220"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9306,
    stopColor: "#F15A22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveBidNameBg);
export default __webpack_public_path__ + "static/media/liveBidNameBg.d863e8616e9c2c6602530f20225dabe5.svg";
export { ForwardRef as ReactComponent };